<template>
  <div class="add">
    <contract-form operate-type="add" @toContractList="transferTabChange"></contract-form>
  </div>
</template>

<script>
import ContractForm from "./component/form";
export default {
  components: {
    ContractForm
  },
  methods: {
    transferTabChange() {
      this.$emit('toContractList');
    }
  },
}
</script>